import { Component } from '@angular/core';

@Component({
  selector: 'app-bases',
  templateUrl: './bases.component.html',
  styleUrl: './bases.component.css'
})
export class BasesComponent {

}
